export default "__VITE_ASSET__BXuNnleO__"